import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

import RTVDialog from './RTVDialog';
import AdornedButton from '../AdornedButton';

/**
 * Asks the buyer whether they still intend to request a change for a received
 * order. Shown right after they rate the purchase.
 *
 * - "Aún no sé"           => onStillUnsure: review only, order stays received.
 * - "No lo voy a cambiar" => onWontChange: review + the order is completed.
 */
const RTVChangeRequestDialog = ({
  open,
  onClose,
  onStillUnsure,
  onWontChange,
  loading
}) => {
  const { t } = useTranslation();

  return (
    <RTVDialog
      open={open}
      onClose={onClose}
      title="¿Vas a solicitar un cambio?"
      content={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            textAlign: 'center'
          }}
        >
          <Typography style={{ color: '#707070' }}>
            {t('ifNotRequestingChange')}
          </Typography>
          <Typography style={{ color: '#707070', whiteSpace: 'nowrap' }}>
            {t('helpSellerGetPaidFaster')}
          </Typography>
          <Typography style={{ fontWeight: 700, marginTop: '8px' }}>
            Esta acción no se puede deshacer.
          </Typography>
        </div>
      }
      actionSection={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
            width: '100%'
          }}
        >
          <AdornedButton
            variant="outlined"
            color="primary"
            disabled={loading}
            loading={loading}
            onClick={onStillUnsure}
            style={{
              whiteSpace: 'nowrap',
              borderRadius: '25px',
              padding: '8px 24px'
            }}
          >
            Aun no lo sé
          </AdornedButton>
          <AdornedButton
            variant="contained"
            color="primary"
            loading={loading}
            disabled={loading}
            onClick={onWontChange}
            style={{
              whiteSpace: 'nowrap',
              borderRadius: '25px',
              padding: '8px 24px'
            }}
          >
            No lo voy a cambiar
          </AdornedButton>
        </div>
      }
    />
  );
};

export default RTVChangeRequestDialog;
